import React from "react";

const SpecialAnalysis = ({ ...props }) => {
    return (
      <div>
        <p>
          Coming soon
        </p>
      </div>
    );
  };
  
  export default SpecialAnalysis;